export default __webpack_public_path__ + "static/media/open-report.fc93bffa.svg";